import { render, staticRenderFns } from "./EditFinalReview.vue?vue&type=template&id=3a129a3a&scoped=true"
import script from "./EditFinalReview.vue?vue&type=script&lang=js"
export * from "./EditFinalReview.vue?vue&type=script&lang=js"
import style0 from "./EditFinalReview.vue?vue&type=style&index=0&id=3a129a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a129a3a",
  null
  
)

export default component.exports